import React, { useState, useEffect } from "react";
import "./custom.css"; // Custom CSS for styling
import DocumentationViewer from "../components/DocumentationViewer";
import { useNavigate, useParams } from "react-router-dom";
import { markdownPaths } from "../types/markdownPaths";

// Define the available sections as a union type for better typing
type Section = "overview" | "access-token" | "api-calls";

const APIWebReferenceOverviewPage: React.FC = () => {
  const navigate = useNavigate();
  const { section } = useParams<{ section: Section }>();
  const [selectedSection, setSelectedSection] = useState<Section>("overview");

  // Update the selected section based on the URL parameter
  useEffect(() => {
    if (section) {
      setSelectedSection(section);
    }
  }, [section]);

  // Function to switch sections and update the URL
  const handleSectionChange = (section: Section) => {
    setSelectedSection(section);
    navigate(`/api-web-reference/${section}`);
  };

  return (
    <div className="api-concepts-page">
      {/* Horizontal Menu with Section Categories */}
      <nav className="api-concepts-menu bg-gray-100 p-4">
        <ul className="flex justify-center space-x-8">
          <li
            className={`cursor-pointer ${
              selectedSection === "overview" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("overview")}
          >
            Overview
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "access-token"
                ? "text-green-600 font-bold"
                : ""
            }`}
            onClick={() => handleSectionChange("access-token")}
          >
            Access Token
          </li>
          <li
            className={`cursor-pointer ${
              selectedSection === "api-calls" ? "text-green-600 font-bold" : ""
            }`}
            onClick={() => handleSectionChange("api-calls")}
          >
            API Calls
          </li>
        </ul>
      </nav>

      {/* Content Area */}
      <div className="content-area">
        {selectedSection === "overview" && (
          <DocumentationViewer
            filePath={markdownPaths.APIWebReferenceOverviewURL}
          />
        )}

        {selectedSection === "access-token" && (
          <DocumentationViewer
            filePath={markdownPaths.APIWebReferenceAccessTokenURL}
          />
        )}
        {selectedSection === "api-calls" && (
          <DocumentationViewer
            filePath={markdownPaths.APIWebReferenceAPICallsURL}
          />
        )}
      </div>
    </div>
  );
};

export default APIWebReferenceOverviewPage;
